import { FAILURE, IDLE, REQUEST, SUCCESS } from 'src/redux/constants';
import { INFO_USER } from './constants';
import { ThunkAction } from 'redux-thunk';
import { State } from 'src/redux/reducer';
import { InfoUserDataActionTypes } from './types';
import { keycloakData } from 'src/utils/api/api';

export const loadInfoUser =
  (
    func: () => Keycloak.KeycloakPromise<Keycloak.KeycloakProfile, void>,
  ): ThunkAction<Promise<void>, State, null, InfoUserDataActionTypes> =>
  async (dispatch) => {
    dispatch({ type: INFO_USER + REQUEST });
    try {
      const payload = await keycloakData(func);
      dispatch({ type: INFO_USER + SUCCESS, payload });
    } catch (error) {
      dispatch({ type: INFO_USER + FAILURE, error });
    }
  };

export const infoUserIdle = () => ({ type: INFO_USER + IDLE });
